import SystemAnimatedLinearProgressBar from "../../SystemAnimatedLinearProgressBar";
import SystemProgressText from "../../../texts/SystemProgressText";

export default function ExerciserProgressBar({currentProblem, total}) {
    // Used in ExerciserTopBar to display progress bar
    // made of an animated bar and its text

    // BUILD
    return (
        <div className="sm:w-[240px] md:w-[320px] lg:w-[520px] flex space-x-12 items-center">
            <SystemAnimatedLinearProgressBar currentIndex={currentProblem}
                                             total={total} />
            <SystemProgressText currentIndex={currentProblem}
                                total={total} />
        </div>
    )
}